/* eslint-disable react-hooks/exhaustive-deps */
import { formatDate } from 'src/utils/dates';
import React from 'react';
import FullTable from 'src/common/components/FullTable';
import PageLayout from 'src/common/components/PageLayout';
import UtilInputs from 'src/common/components/UtilInputs';
import { columns, filter_form, columnsFilial } from './utils/list_data';
import { useDirectory } from './hooks/useDirectory';

const Directories = () => {
	const {
		users,
		onDispatch,
		filter,
		handleChangeFilter,
		handleChangeUser,
		onClear,
		onValidate,
		organs,
		institutions,
		byAdvisor,
		permission,
		systemLevelRole,
		hide,
		pagination,
		currentPage,
		setCurrentPage,
		totalResults,
		handlePagination,
		//allUsers,
		loadingAll,
	} = useDirectory();

	const rowExt = (data) => {
		let textdata = (
			<div style={{ maxWidth: '100%' }}>
				<p>
					<b>NOMBRE: </b> {data.nombre}
				</p>
				<p>
					<b>APELLIDO PATERNO: </b> {data.apellidoPaterno}
				</p>
				<p>
					<b>APELLIDO MATERNO: </b> {data.apellidoMaterno}
				</p>
				<p>
					<b>ORG / DEPEND: </b> {data.unidadAdministrativa}
				</p>
				{data.miembro === false ? (
					<p>
						<b>CARGO: </b> {data.position}
					</p>
				) : (
					''
				)}
				<p>
					<b>SECTOR: </b> {data.section}
				</p>
				<p>
					<b>DOMICILIO: </b> {data.domicilio}
				</p>
				<p>
					<b>TELEFONO: </b> {data.telefono}
				</p>
				<p>
					<b>CORREO ELECTRÓNICO: </b> {data.email}
				</p>
				<p>
					<b>OFICIO: </b> {data.oficio}
				</p>
				<p>
					<b>PERFIL: </b> {data.profile}
				</p>
				{data.miembro === false ? (
					<p>
						<b>ÓRGANOS COLEGIADOS: </b> {data.organos}
					</p>
				) : (
					<p>
						<b>ÓRGANOS COLEGIADOS Y SU CARGO: </b> {data.organos}
					</p>
				)}
			</div>
		);

		return textdata;
	};

	const type = localStorage.getItem('type');

	return (
		<PageLayout title="Directorio">
			<UtilInputs
				formValues={filter}
				inputValues={filter_form(
					onValidate,
					onDispatch,
					onClear,
					organs,
					institutions,
					byAdvisor,
					type,
					permission.includes(systemLevelRole)
				)}
				onValuesChange={handleChangeFilter}
				onKeyPress={handleChangeUser}
			/>
			<FullTable
				idTable="users"
				title="Información de Integrantes"
				items={users}
				columns={type ? columnsFilial(hide) : columns(hide)}
				createExcel={`Integrantes de organos colegiados_${formatDate(
					'P p'
				)}.xlsx`}
				PDFFileName={`Integrantes de organos colegiados_${formatDate('P p')}.pdf`}
				expand={true}
				dataRow={rowExt}
				showPagination
				handlePagination={handlePagination}
				sizePerPageTable={pagination}
				totalPages={totalResults}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
				otherItems={users}
				disabledExcel={loadingAll}
				disabledPdf={loadingAll}
			/>
		</PageLayout>
	);
};

export default Directories;
